<template lang="pug">
  #app(@contextmenu.prevent='')
    transition(name='fade')
      .loaderContainer(v-if="$store.state.showLoader")
        .loader-ring
          .loader-ring-light
    .container-fluid.main-body
      router-view(:key="$route.fullPath" :lang="lang")
    w2-navigation(:lang="lang")
</template>

<script>
import Navigation from '@/components/Navigation'
export default {
  name: 'app',
  data () {
    return {
    }
  },
  components: {
    'w2-navigation': Navigation
  },
  computed: {
    isUserAuthenticated: {
      get () {
        return this.$store.state.isUserAuthenticated
      }
    },
    lang: {
      get () {
        return this.$store.getters.lang
      }
    },
    user: {
      get () {
        return this.$store.getters.user
      }
    }
  },
  beforeCreate () {
    const getCookie = name => {
      let a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`)
      return a ? a[1] : ''
    }

    if (!this.user && getCookie('userid')) {
      let cookies = document.cookie.split(';')
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i]
        var eqPos = cookie.indexOf('=')
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      }
      window.location.href = '/'
    }
  }
}
</script>

<style lang="sass">
@import "sass/app"
</style>



// WEBPACK FOOTER //
// src/App.vue